import { render, staticRenderFns } from "./FormData.vue?vue&type=template&id=165c9b8c&scoped=true&"
import script from "./FormData.vue?vue&type=script&lang=ts&"
export * from "./FormData.vue?vue&type=script&lang=ts&"
import style0 from "./FormData.vue?vue&type=style&index=0&id=165c9b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c9b8c",
  null
  
)

export default component.exports